export default __webpack_public_path__ + "resources/icons/d321-0002.webp";